import { Reducer } from "@reduxjs/toolkit";

export enum FeaturesName {
  MAIN = "main",
  ERROR = "error",
  LAYOUT = "layout",
  IMAGE_DETECTION = "imageDetection",
  MAP = "map",
  PROJECT_REPORT = "projectReport",
  SETTINGS = "settings",
  TEAM_AND_STAFF = "teamAndStaff",
  AUTH = "auth",
  MODAL = "modal",
  UNITS_MANAGER = "unitsManager",
  LAYERS_MANAGER = "layersManager",
  MISSIONS_MANAGER = "missionsManager"
}

export interface Feature<TActions = unknown> {
  enabled?: boolean;
  reducer?: Reducer<any>;
  actions?: TActions;
  selectors?: Record<string, (...args: any[]) => any>;
  pages?: Record<string, React.FC<any>>;
  [key: string]: any;
}

export type FeatureConfig = {
  name: FeaturesName;
  module: Feature;
};
